var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-wrapper"},[(_vm.open)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.$listeners.clickOutside),expression:"$listeners.clickOutside"}],class:( _obj = {
      dropdown: true
    }, _obj[_vm.dropdownClass] = _vm.dropdownClass !== undefined, _obj )},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }